var render = function render(){var _vm=this,_c=_vm._self._c;return _c('assets-library',{attrs:{"tip":"上传图片大小不超过5M","scroll-height":"auto","limit":5}})
}
var staticRenderFns = []

export { render, staticRenderFns }